import { useMemo } from 'react';
import classes from './RealPlayClientInfo.module.scss';
import { ProgressBar } from 'shared_ui_components';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';

const RealPlayClientInfo = () => {
  const { scenarios, client, attitude, customer_context } = RealPlayRecordDataHelper();

  const scenariosCompleted = useMemo(() => {
    const responses = (scenarios ?? []).map((sc) =>
      Object.keys(sc?.response_retake || {})?.length > 0 ? sc?.response_retake : sc?.response
    );
    return responses?.filter((res) => res && res?.video)?.length;
  }, [scenarios]);

  return (
    <div className={classes.container}>
      <span>Meet your Prospect: {client?.name}</span>
      <div className={classes.customerContainer}>
        <div>
          <p className={classes.deadlineTitle}>Role:</p>
          <p>{customer_context?.role}</p>
        </div>
        <div>
          <p className={classes.deadlineTitle}>Industry:</p>
          <p>{customer_context?.industry}</p>
        </div>
        <div>
          <p className={classes.deadlineTitle}>Situation: </p>
          <p>{customer_context?.situation}</p>
        </div>
      </div>
      <div className={classes.attitude}>
        <div>{attitude?.name ?? ''}</div>
      </div>
      <div className={classes.scenarioCompleted}>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem', alignItems: 'center' }}>
          <span>{`${scenariosCompleted || 0}/${scenarios?.length || 0}`} </span>
          <p style={{ marginTop: 2 }}>Scenarios completed</p>
        </div>
        <div>
          <ProgressBar
            value={(scenariosCompleted * 100) / scenarios?.length}
            max={100}
            hideLabel={true}
          />
        </div>
      </div>
    </div>
  );
};

export default RealPlayClientInfo;
